import { render, staticRenderFns } from "./MyPageHeaderComponent.vue?vue&type=template&id=70197f59&scoped=true"
import script from "./MyPageHeaderComponent.vue?vue&type=script&lang=js"
export * from "./MyPageHeaderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70197f59",
  null
  
)

export default component.exports